<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 ">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4  float-left">Lista Clientes</p>
          <button
 
          (click)="crearPDF()"
          class="btn btn-primary"
         >
          <i class="fa fa-print"></i>
         </button>
          <a (click)="createClient()" class="btn btn-success float-right">
            Crear Clientes</a
          >
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <input
                class="form-control"
                #searchTerm
                (keyup)="search(searchTerm.value)"
                placeholder="Buscar clientes..."
              />
            </div>
            <div class="col-md-6">
              <select
                class="custom-select"
                id="inputGroupSelect02"
                (change)="onChange($event.target.value)"
              >
                <option value="">Seleccione Vendedor</option>
                <option *ngFor="let vendedor of users" [value]="vendedor.id">
                  {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                >
              </select>
            </div>
          </div>

          <br />

          <div *ngIf="clientes && !clientService.isLoading" class="row">
            <div class="col-md-12">
              <table
                class="table-condensed table-hover table-bordered"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <!-- <th>Foto</th> -->
                    <th>Nombre Completo</th>
                    <th>Telefono</th>
                    <th>Nit</th>
                    <th>Direccion</th>
                    <th>vendedor</th>

                    <!--                  <th>Habilitado</th>-->
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody *ngFor="let client of clientes.data; let i = index">
                  <tr>
                    <th scope="row">
                      {{
                        i + 1 + (clientes.current_page - 1) * clientes.per_page
                      }}
                    </th>
                    <!-- <td>
                      <img
                        height="50"
                        width="50"
                        [src]="imageURL + 'client/' + client.foto"
                        alt=""
                      />
                    </td> -->
                    <td>{{ client.nombres + ' ' + client.apellidos }}</td>
                    <td>{{ client.celular }}</td>
                    <td>{{ client.ci_nit }}</td>
                    <td>{{ client.direccion }}</td>
                    <td>
                      {{
                        client.vendedor.username
                      }}
                    </td>
                    <!-- <td class="mt-2">
                <label
                  class="switch switch_type1"
                  role="switch"
                  *ngIf="client.habilitado == true"
                >
                  <input
                    type="checkbox"
                    class="switch__toggle"
                    (click)="enableClient(client.cliente_id)"
                    checked="false"
                  />
                  <span class="switch__label"></span>
                </label>
                <label
                  class="switch switch_type1"
                  role="switch"
                  *ngIf="client.habilitado == false"
                >
                  <input
                    type="checkbox"
                    class="switch__toggle"
                    (click)="enableClient(client.cliente_id)"
                  />
                  <span class="switch__label"></span>
                </label>
              </td>-->
                    <td>
                      <button
                        type="button"
                        class="btn btn-default btn-sm"
                        (click)="editModal(client.cliente_id)"
                      >
                        <i
                          class="fa fa-pencil-square-o text-info"
                          style="font-size: 20px"
                        ></i></button
                      >  
                      <button
                      type="button"
                      class="btn btn-default btn-sm"
                      (click)="eliminar(client.cliente_id)"
                    >
                      <i
                        class="fa fa-trash text-danger"
                        style="font-size: 20px"
                      ></i>
                    </button>

                    
                    </td>
                  </tr>
                </tbody>
              </table>

              <p>
                Mostrando clientes {{ clientes.from }} a {{ clientes.to }} de
                {{ clientes.total }}
              </p>
              <p>
                Página {{ clientes.current_page }} de {{ clientes.last_page }}
              </p>
              <input
                type="number"
                style="width: 50px;"
                [(ngModel)]="paginanum"
                name="home"
                required
                min="0"
                step="1"
              />
              <button (click)="searchPage(paginanum)">
                ir
              </button>
              <br />
              <button (click)="prevPage()" [disabled]="!clientes.prev_page_url">
                Anterior
              </button>
              <button (click)="nextPage()" [disabled]="!clientes.next_page_url">
                Siguiente
              </button>
            </div>
          </div>
          <p *ngIf="clientService.isLoading">Cargando...</p>
        </div>
      </div>
    </div>
  </div>
</div>
